<template>
  <div>
    <b-modal
      ref="modal-primary "
      id="modal-primary"
      modal-class="modal-primary"
      centered
      title="Stok Ekle/Güncelle"
    >
      <div>
        <b-row>
          <b-col>
            <vs-card>
              <b-form @submit.prevent>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Stok No/Stok Adı"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8" v-if="gelenDurum == 'true'">
                    <p>{{ gelenSTOCKNO }}/{{ gelenSTOCKNAME }}</p>
                  </b-col>
                  <b-col cols="8" v-else>
                    <vue-autosuggest
                      v-model="querystok"
                      style="width: 100%"
                      :suggestions="filteredOptionsstok"
                      :get-suggestion-value="getSuggestionValuestok"
                      :input-props="{
                        id: 'autosuggest__input',
                        class: 'form-control',
                        placeholder: 'Stok Kodu / Stok Adı',
                      }"
                      @input="onInputChangestok"
                    >
                      <template slot-scope="{ suggestion }">
                        <div
                          class="d-flex align-items-center my-suggestion-item"
                        >
                          <div class="detail ml-50 my-suggestion-item">
                            <b-card-text class="mb-0">
                              {{ suggestion.item.STOCKNO }} /
                              {{ suggestion.item.A }}
                            </b-card-text>
                          </div>
                        </div>
                      </template>
                    </vue-autosuggest>
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Cari Adı"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <vue-autosuggest
                      v-model="query"
                      style="width: 100%"
                      :suggestions="filteredOptions"
                      :get-suggestion-value="getSuggestionValue"
                      :input-props="{
                        id: 'autosuggest__input',
                        class: 'form-control',
                        placeholder: 'Cari Adı',
                      }"
                      @input="onInputChange"
                    >
                      <template slot-scope="{ suggestion }">
                        <div
                          class="d-flex align-items-center my-suggestion-item"
                        >
                          <div class="detail ml-50 my-suggestion-item">
                            <b-card-text class="mb-0">
                              {{ suggestion.item.ACTNAME }}
                            </b-card-text>
                          </div>
                        </div>
                      </template>
                    </vue-autosuggest>
                  </b-col>
                </b-row>

                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Fiyat"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-row>
                      <b-col cols="3" style="padding-right: 0px">
                        <v-select
                          :color="select2"
                          v-model="fiyatSecilen"
                          :options="fiyatlar"
                          @input="changedLabel"
                          style="
                            border-top-right-radius: 0;
                            border-bottom-right-radius: 0;
                          "
                          autocomplete
                          ref="selectElement"
                        >
                          <template slot="option" slot-scope="option">
                            {{ option.ACTID }} / {{ option.FTUR }}
                          </template>
                        </v-select>
                      </b-col>
                      <b-col cols="9" style="padding-left: 0px">
                        <b-form-input
                          style="
                            border-top-left-radius: 0;
                            border-bottom-left-radius: 0;
                          "
                          id="h-first-name"
                          v-model="inputValFiyat"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Miktar"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input id="h-first-name" v-model="miktar" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="İstenen Tarih"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-datepicker
                      v-model="istenenTarih"
                      :placeholder="getNow()"
                      size="sm"
                      local="en"
                      class="mb-2"
                      today-variant="danger"
                      :start-weekday="weekday"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Açıklama"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <vs-textarea label="Açıklama" v-model="textareaNot" />
                  </b-col>
                </b-row>
              </b-form>
            </vs-card>
          </b-col>
        </b-row>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="danger"
            size="md"
            class="float-right"
            @click="cancel()"
          >
            İptal
          </b-button>
          <b-button
            style="margin-right: 25px"
            size="md"
            variant="success"
            class="float-right"
            @click="sepeteEkle()"
          >
            Ekle
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
import vSelect from "vue-select";
import moment from "moment";
export default {
  props: ["gelenDurum"],
  data() {
    return {
      weekday:1,
      inputValFiyat: "",
      select2: "primary",
      fiyatSecilen: "",
      stokAd: "",
      stokNo: "",
      fiyat: "",
      miktar: "",
      istenenTarih: "",
      textareaNot: "",
      cariAdi: "",
      query: "",
      querystok: "",
      filteredOptions: [],
      filteredOptionsstok: [],
      datasuggest: [],
      datasuggeststok: [],
      fiyatlar: [],
      ACTNAME: "",
      ACTID: "",
      gelenSTOCKNO: "",
      gelenSTOCKID: "",
      gelenSTOCKNAME: "",
      stokIdSecilen: "",
      RECEIPTID: "",
      ITEMNO: "",
    };
  },
  components: { "v-select": vSelect },
  methods: {
    changedLabel(event) {
      this.inputValFiyat = event.ACTID;
    },
    getSuggestionValuestok(suggestion) {
      this.stokIdSecilen = suggestion.item.STOCKID;
      // if(suggestion)
      this.isDisabled = false;
      return suggestion.item.STOCKNO + " / " + suggestion.item.A;
    },
    getSuggestionValue(suggestion) {
      this.ACTNAME = suggestion.item.ACTNAME;
      this.ACTID = suggestion.item.ACTID;

      // if(suggestion)
      //   this.isDisabled = false;
      return suggestion.item.ACTNAME;
    },
    getNow() {
      const today = new Date();
      const date =
        today.getDate() +
        "." +
        (today.getMonth() + 1) +
        "." +
        today.getFullYear();

      const dateTime = date;
      return dateTime;
    },
    cancel() {
      this.$refs["modal-primary "].hide();
      this.miktar = "";
      this.inputValFiyat = "";
      this.istenenTarih = "";
      this.textareaNot = "";
      this.ACTID = "";
      this.query = "";
      this.querystok = "";
    },
    parseDate(params) {
      return moment(String(params.value)).format("DD.MM.YYYY");
    },
    sepeteEkle() {
      var vs = this.$vs;
      var vm = this;
      var today = new Date();
      var formattoday = vm.getNow();
      const soap = require("soap");
      const url = state.sistemAddress;
      console.log(vm.gelenDurum);

      if (vm.gelenDurum == "true") {
        var args = {
          ISLEM: "UPDATE",
          STOCKID: Store.state.account.stokId,
          RECEIPTID: vm.RECEIPTID,
          ITEMNO: vm.ITEMNO,
          QUANTITY: vm.miktar,
          PRICE: vm.inputValFiyat,
          TOTAL: vm.miktar * vm.inputValFiyat,
          DESCRIPTION: vm.textareaNot,
          REQUIREDDATE: moment(String(vm.istenenTarih)).format("YYYY-MM-DD"),
          ACTID: vm.ACTID, //seçilen
          token: Store.state.tokenId,
          STATUS: "2",
        };
        soap.createClient(url, function (err, client) {
          client.INT_Sal_SatinalmaTalepIslem(args, function (err, result) {
            if (result.INT_Sal_SatinalmaTalepIslemResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.INT_Sal_SatinalmaTalepIslemResult);
              vs.notify({
                title: "Sepet",
                text: "Güncellendi",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
            } catch (error) {
              vs.notify({
                title: "Güncelleme",
                text: "Güncellenirken Hata Oluştu",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          });
        });
      } else {
        if (vm.ACTID == "") vm.ACTID = 0;
        var formattoday = new Date();

        const args = {
          token: Store.state.tokenId,
          STOCKID: vm.stokIdSecilen,
          TRANSDATE: moment(String(formattoday)).format("YYYY-MM-DD"),
          TALEPTARIHI: vm.istenenTarih,
          EMPLOYEEID: Store.state.UserId,
          ADET: vm.miktar,
          FIYAT: vm.inputValFiyat,
          TUTAR: vm.miktar * vm.inputValFiyat,
          ACTID: vm.ACTID,
          ACIKLAMA: vm.textareaNot,
          STATUS: "2",
          IND1: "0",
          IND2: "0",
          IND3: "0",
        };
        console.log(args);

        soap.createClient(url, function (err, client) {
          client.INT_Sal_SatinalmaTalepEkle(args, function (err, result) {
            if (result.INT_Sal_SatinalmaTalepEkleResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              //   vm.veriler = JSON.parse(result.INT_Sal_SatinalmaTalepIslemResult);
              vs.notify({
                title: "Sepet",
                text: "Güncellendi",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
            } catch (error) {
              /*     vs.notify({
                title: "Güncelleme2",
                text: "Güncellenirken Hata Oluştu",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });*/
            }
          });
        });
      }
      vm.miktar = "";
      vm.inputValFiyat = "";
      vm.istenenTarih = "";
      vm.textareaNot = "";
      vm.ACTID = "";
      vm.query = "";
      vm.querystok = "";
      vm.$root.$emit("talepHavuzuList");
      vm.$refs["modal-primary "].hide();
    },
    onInputChangestok(text) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        token: Store.state.tokenId,
        ARANAN: text,
      };
      soap.createClient(url, function (err, client) {
        client.INT_Ls_Stock_StokSec(args, function (err, result) {
          if (result.INT_Ls_Stock_StokSecResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.INT_Ls_Stock_StokSecResult);
          vm.datasuggeststok = vm.veriler;

          if (text === "" || text === undefined) {
            vm.isDisabled = true;
            return;
          }
          vm.filteredOptionsstok = [
            {
              data: vm.datasuggeststok.filter((option) => {
                return (
                  option.A.toLowerCase().indexOf(vm.querystok.toLowerCase()) >
                    -1 ||
                  option.STOCKNO.toLowerCase().indexOf(
                    vm.querystok.toLowerCase()
                  ) > -1
                );
              }),
            },
          ];
        });
      });
    },
    onInputChange(text) {
      this.$refs["modal-primary "].show();
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        ARANAN: "",
      };

      soap.createClient(url, function (err, client) {
        client.INT_Ls_Act_ActSec(args, function (err, result) {
          if (result.INT_Ls_Act_ActSecResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.INT_Ls_Act_ActSecResult);
          vm.datasuggest = vm.veriler;

          if (text === "" || text === undefined) {
            vm.isDisabled = true;
            return;
          }
          vm.filteredOptions = [
            {
              data: vm.datasuggest.filter((option) => {
                return (
                  option.ACTNAME.toLowerCase().indexOf(vm.query.toLowerCase()) >
                  -1
                );
              }),
            },
          ];
        });
      });
    },
    detayList() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        STOCKID: vm.gelenSTOCKID,
      };

      soap.createClient(url, function (err, client) {
        client.INT_Ls_Stock_TalepStokSec(args, function (err, result) {
          if (result.INT_Ls_Stock_TalepStokSecResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_Ls_Stock_TalepStokSecResult);
            vm.fiyatlar = vm.veriler;
          } catch (error) {}
        });
      });
    },
    sepetGuncelle(gelenData) {
      this.$refs["modal-primary "].show();
      var vm = this;
      if (vm.gelenDurum == "true") {
        vm.gelenSTOCKNO = Store.state.account.stokSTOCKNO;
        vm.gelenSTOCKID = Store.state.account.stokId;
        vm.gelenSTOCKNAME = Store.state.account.stokSTOCKNAME;
        vm.RECEIPTID = gelenData.RECEIPTID;
        vm.ITEMNO = gelenData.ITEMNO;
        vm.inputValFiyat = gelenData.PRICE;
        vm.miktar = gelenData.QUANTITY;
        vm.istenenTarih = gelenData.REQUIREDDATE;
        vm.textareaNot = gelenData.DESCRIPTION;
      }
      vm.detayList();
    },
  },
};
</script>
<style lang="scss">
#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}
[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}
[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}
[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}
.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}
[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}
[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}
.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
#autosuggest__input {
  outline: none;
  position: relative;
  display: block;
  width: 100%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

#autosuggest__input.autosuggest__input-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}
[dir] .autosuggest__results .autosuggest__results-item {
  padding: 7px !important;
}
[dir] .card-text:last-child {
  color: black;
  font-weight: 500;
}
.autosuggest__results {
  font-weight: 300;
  margin: 0;
  position: absolute;
  z-index: 10000001;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: white;
  padding: 0px;
  max-height: 100px;
  overflow-y: scroll;
}

.autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.autosuggest__results .autosuggest__results-item {
  cursor: pointer;
  padding: 15px;
}

#autosuggest ul:nth-child(1) > .autosuggest__results-before {
  border-top: none;
}

.autosuggest__results .autosuggest__results-before {
  color: gray;
  font-size: 11px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;
}

.autosuggest__results .autosuggest__results-item:active,
.autosuggest__results .autosuggest__results-item:hover,
.autosuggest__results .autosuggest__results-item:focus,
.autosuggest__results
  .autosuggest__results-item.autosuggest__results-item--highlighted {
  background-color: #f6f6f6;
}
</style>